import { liveMatches, upcomingMatches, replayMatches, userStreams } from '../../../mocks/sportsData';
import Button from '../../../components/base/Button';
import VideoPreview from '../../../components/feature/VideoPreview';
import { useState, useEffect, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { getLiveCategorys,getliveFocusDel,getliveFocusAdd, getLiveList, getmatchTeamList, getmatchTeamAdd, getmatchTeamDel } from '@/services/live';
import { message } from 'antd';
import { getadvertiseList } from '../../../services/setting';
interface SportCategory {
  id: number;
  name: string;
  logo?: string;
  sort?: number;
  state?: number;
  add_time?: string;
  number?: number;
}

interface LiveMatchesProps {
  selectedSport: SportCategory;
  isLivePage?: boolean;
  liveList: any[];
}

export default function LiveMatches({ selectedSport, isLivePage = false }: LiveMatchesProps) {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<'live' | 'upcoming' | 'replays' | 'following'>('live');
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [previewVideo, setPreviewVideo] = useState<any>(null);
  const [hoveredVideo, setHoveredVideo] = useState<string | null>(null);
  const [previewTime, setPreviewTime] = useState<{ [key: string]: number }>({});
  const [selectedTeam, setSelectedTeam] = useState<any>(null);
  const [liveList, setLiveList] = useState<any[]>([]);
  const videoRefs = useRef<{ [key: string]: HTMLVideoElement | null }>({});
  const previewIntervals = useRef<{ [key: string]: NodeJS.Timeout }>({});
  const itemsPerPage = isLivePage ? 20 : 12;
  const [favoriteReplays, setFavoriteReplays] = useState<Set<string>>(new Set());
  const [followingTeams, setFollowingTeams] = useState<any[]>([]);
 const [loadingTeamId, setLoadingTeamId] = useState<number | null>(null);
  
 const [teamMatches, setTeamMatches] = useState<any[]>([]);

 const [adList, setAdList] = useState<any[]>([]);
 const [adListobj, setAdListobj] = useState<{ }>({ });
 const [adListobj2, setAdListobj2] = useState<{ }>({ });


 // 收藏功能
  const handleFavoriteReplay = (e: React.MouseEvent, match: any) => {
    e.preventDefault();
    e.stopPropagation();
    const isFavorited = favoriteReplays.has(match.id)|| match.is_focus;
    const action = match.is_focus ? getliveFocusDel : getliveFocusAdd;
        action({ id: match.id }).then(res => {
          if (!res || res.status !== 1) {
            // If the API call fails, revert the state to its original value
            message.success(res?.info || '操作失败');
            // Optional: show an error message to the user
            console.error('Failed to update focus status:', res?.msg);
          }else{
            fetchLiveList()
            message.success(res?.info || '操作成功');
          }
        }).catch(error => {
          console.error('Error updating focus status:', error);
        });
    if (isFavorited) {
      setFavoriteReplays(prev => {
        const newSet = new Set(prev);
        newSet.delete(match.id);
        localStorage.setItem('favoriteReplays', JSON.stringify(Array.from(newSet)));
        return newSet;
      });
      showFavoriteMessage('已取消收藏');
    } else {
      setFavoriteReplays(prev => {
        const newSet = new Set([...prev, match.id]);
        localStorage.setItem('favoriteReplays', JSON.stringify(Array.from(newSet)));
        return newSet;
      });
      showFavoriteMessage('已收藏到我的收藏');
      const button = e.currentTarget as HTMLElement;
      button.classList.add('animate-pulse');
      setTimeout(() => {
        button.classList.remove('animate-pulse');
      }, 600);
    }
  };

  const showFavoriteMessage = (message: string) => {
    const messageDiv = document.createElement('div');
    messageDiv.className = 'fixed top-4 right-4 bg-green-500 text-white px-4 py-3 rounded-lg shadow-lg z-50 flex items-center animate-in slide-in-from-top-2 duration-300';
    messageDiv.innerHTML = `<i class="ri-check-line mr-2"></i>${message}`;
    document.body.appendChild(messageDiv);
    setTimeout(() => {
      if (document.body.contains(messageDiv)) {
        messageDiv.classList.add('animate-out', 'slide-out-to-top-2');
        setTimeout(() => {
          if (document.body.contains(messageDiv)) {
            document.body.removeChild(messageDiv);
          }
        }, 300);
      }
    }, 3000);
  };

  useEffect(() => {
    const savedFavorites = localStorage.getItem('favoriteReplays');
    if (savedFavorites) {
      try {
        const favoritesArray = JSON.parse(savedFavorites);
        setFavoriteReplays(new Set(favoritesArray));
      } catch (error) {
        console.error('Failed to parse favorite replays:', error);
      }
    }
        // 获取广告列表
    getadvertiseList({ type: '2' }).then((res: any) => {
      if (res && res.status === 1 && Array.isArray(res.data?.lists)) {
        const filteredAds = res.data.lists.filter((ad: any) => ad.place === 2);
        const filteredAds1 = res.data.lists.filter((ad: any) => ad.place === 6);
        
        setAdList(res.data.lists);
        setAdListobj(filteredAds[0] || {});
        setAdListobj2(filteredAds1[0] || {});
      }
    });
  }, []);


  const handleAdClick = (url: string) => {
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  const fetchLiveList = () => {
    let state = '1';
    if (activeTab === 'upcoming') state = '0';
    if (activeTab === 'replays') state = '3';
    const category_id = selectedSport && selectedSport.name !== '全部' ? selectedSport.id : '';
    const keyword = searchQuery || '';
    getLiveList({ category_id, type: '',page_size:'500', state, keyword }).then((res: any) => {
      if (res && res.status === 1 && Array.isArray(res.data?.lists)) {
        setLiveList(res.data.lists);
      } else if (res && res.status === 1 && Array.isArray(res.data)) {
        setLiveList(res.data);
      } else {
        setLiveList([]);
      }
    });
    setCurrentPage(1);
  };
  useEffect(() => {
    fetchLiveList()
  }, [activeTab, selectedSport, searchQuery]);

   // 监听tab切换到关注时，请求队伍列表
  useEffect(() => {
    if (activeTab === 'following') {
      const category_id = selectedSport && selectedSport.name !== '全部' ? selectedSport.id : '';
      const keyword = searchQuery || '';
      getmatchTeamList({type:1,category_id,keyword}).then((res: any) => {
        if (res && res.status === 1 && Array.isArray(res.data?.lists)) {
          setFollowingTeams(res.data.lists);
        } else {
          setFollowingTeams([]);
        }
      });
      setCurrentPage(1);
    }
  }, [activeTab, selectedSport, searchQuery]);

    // Fetch matches for a selected team
  useEffect(() => {
    if (selectedTeam) {
      getLiveList({
        keyword: selectedTeam.name,
        category_id: '',
        type: '',
        state: '9' // 9 for all states: live, upcoming, replay
      }).then(res => {
        if (res && res.status === 1 && Array.isArray(res.data?.lists)) {
          setTeamMatches(res.data.lists);
        } else {
          setTeamMatches([]);
        }
      });
    } else {
      setTeamMatches([]); // Clear if no team is selected
    }
    setCurrentPage(1); // Reset to first page when team changes
  }, [selectedTeam]);


  // 关注/取消关注操作
  const handleFollowToggle = async (team: any) => {
    setLoadingTeamId(team.id);
    const category_id = selectedSport && selectedSport.name !== '全部' ? selectedSport.id : '';
    const keyword = searchQuery || '';
    try {
      if (team.state === 1) {
        // 已关注，取消关注
        const res = await getmatchTeamDel({ id: team.id });
        if (res && res.status === 1) {
          // 刷新关注列表
          getmatchTeamList({type:1,category_id,keyword}).then((res: any) => {
            setFollowingTeams(res?.data?.lists || []);
          });
        }else{
          message.error(res?.info || '取消关注失败');
        }
      } else {
        // 未关注，添加关注
        const res = await getmatchTeamAdd({ id: team.id });
        if (res && res.status === 1) {
          getmatchTeamList({type:1,category_id,keyword}).then((res: any) => {
            setFollowingTeams(res?.data?.lists || []);
          });
        }else{
          message.error(res?.info || '关注失败');
        }
      }
    } catch (error) {
      console.error('Follow toggle error:', error);
      message.error(error?.info ||'操作失败，请稍后重试');
    } finally {
      setLoadingTeamId(null);
    }
  };
  // const followingTeams = [
  //   {
  //     id: 1,
  //     name: '曼城',
  //     logo: 'https://readdy.ai/api/search-image?query=Manchester%20City%20football%20club%20logo%2C%20minimalist%20blue%20shield%20design%20with%20sky%20blue%20background%2C%20professional%20soccer%20team%20emblem%2C%20clean%20and%20modern%20sports%20logo%20design&width=100&height=100&seq=mancity-logo&orientation=squarish',
  //     sport: '足球',
  //     league: '英超联赛',
  //     followers: 125000,
  //     upcomingMatches: 3,
  //     recentForm: ['W', 'W', 'D', 'W', 'L']
  //   },
  //   {
  //     id: 2,
  //     name: '湖人',
  //     logo: 'https://readdy.ai/api/search-image?query=Los%20Angeles%20Lakers%20basketball%20team%20logo%2C%20purple%20and%20gold%20colors%2C%20professional%20NBA%20team%20emblem%2C%20clean%20design%2C%20modern%20basketball%20logo&width=100&height=100&seq=lakers-logo&orientation=squarish',
  //     sport: '篮球',
  //     league: 'NBA',
  //     followers: 98000,
  //     upcomingMatches: 2,
  //     recentForm: ['W', 'L', 'W', 'W', 'W']
  //   },
  //   {
  //     id: 3,
  //     name: '皇家马德里',
  //     logo: 'https://readdy.ai/api/search-image?query=Real%20Madrid%20football%20club%20logo%2C%20white%20royal%20crown%20design%2C%20elegant%20soccer%20team%20emblem%2C%20classic%20Spanish%20football%20club%20badge%20with%20white%20and%20gold%20colors&width=100&height=100&seq=realmadrid-logo&orientation=squarish',
  //     sport: '足球',
  //     league: '西甲联赛',
  //     followers: 156000,
  //     upcomingMatches: 4,
  //     recentForm: ['W', 'W', 'W', 'D', 'W']
  //   },
  //   {
  //     id: 4,
  //     name: '勇士',
  //     logo: 'https://readdy.ai/api/search-image?query=Golden%20State%20Warriors%20basketball%20team%20logo%2C%20blue%20and%20yellow%20colors%2C%20professional%20NBA%20team%20emblem%2C%20modern%20basketball%20logo%20with%20warrior%20theme&width=100&height=100&seq=warriors-logo&orientation=squarish',
  //     sport: '篮球',
  //     league: 'NBA',
  //     followers: 87000,
  //     upcomingMatches: 1,
  //     recentForm: ['L', 'W', 'W', 'L', 'W']
  //   },
  //   {
  //     id: 5,
  //     name: '巴塞罗那',
  //     logo: 'https://readdy.ai/api/search-image?query=FC%20Barcelona%20football%20club%20logo%2C%20blue%20and%20red%20stripes%20design%2C%20professional%20soccer%20team%20emblem%2C%20classic%20Catalan%20football%20club%20badge&width=100&height=100&seq=barcelona-logo&orientation=squarish',
  //     sport: '足球',
  //     league: '西甲联赛',
  //     followers: 143000,
  //     upcomingMatches: 3,
  //     recentForm: ['W', 'D', 'W', 'W', 'L']
  //   },
  //   {
  //     id: 6,
  //     name: '网球',
  //     logo: 'https://readdy.ai/api/search-image?query=professional%20tennis%20tournament%20logo%2C%20clean%20white%20and%20green%20design%2C%20tennis%20ball%20and%20racket%20elements%2C%20modern%20sports%20competition%20emblem&width=100&height=100&seq=tennis-logo&orientation=squarish',
  //     sport: '网球',
  //     league: 'ATP巡回赛',
  //     followers: 45000,
  //     upcomingMatches: 2,
  //     recentForm: ['W', 'W', 'L', 'W', 'W']
  //   }
  // ];

  const getTeamMatches = (team: any) => {
    const teamMatches = [
      {
        id: `${team.id}-match-1`,
        title: `${team.name} vs 对手队伍A`,
        category: team.sport,
        league: team.league,
        status: 'live',
        time: "进行中 75'",
        thumbnail: `https://readdy.ai/api/search-image?query=professional%20$%7Bteam.sport%7D%20match%20in%20progress%2C%20modern%20sports%20stadium%20with%20bright%20lighting%2C%20players%20competing%20in%20$%7Bteam.sport%7D%20game%2C%20dynamic%20sports%20action%20scene%20with%20vibrant%20green%20field&width=400&height=300&seq=${team.id}-match-1&orientation=landscape`,
        viewers: Math.floor(Math.random() * 50000) + 10000,
        videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4'
      },
      {
        id: `${team.id}-match-2`,
        title: `${team.name} vs 对手队伍B`,
        category: team.sport,
        league: team.league,
        status: 'upcoming',
        time: '2024-01-20 20:00',
        thumbnail: `https://readdy.ai/api/search-image?query=upcoming%20$%7Bteam.sport%7D%20match%20preview%2C%20professional%20sports%20venue%20preparation%2C%20$%7Bteam.sport%7D%20stadium%20before%20game%20starts%2C%20anticipation%20atmosphere%20with%20team%20colors&width=400&height=300&seq=${team.id}-match-2&orientation=landscape`
      },
      {
        id: `${team.id}-match-3`,
        title: `${team.name} vs 对手队伍C`,
        category: team.sport,
        league: team.league,
        status: 'replay',
        date: '2024-01-15',
        duration: '2:15:30',
        views: Math.floor(Math.random() * 100000) + 20000,
        thumbnail: `https://readdy.ai/api/search-image?query=$%7Bteam.sport%7D%20match%20highlights%20and%20replay%2C%20exciting%20sports%20moments%2C%20professional%20$%7Bteam.sport%7D%20game%20action%20with%20dynamic%20player%20movements%20and%20stadium%20atmosphere&width=400&height=300&seq=${team.id}-match-3&orientation=landscape`,
        videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4'
      }
    ];
    return teamMatches;
  };

  const formatViewers = (count: number) => {
    if (count >= 1000000) return `${(count / 1000000).toFixed(1)}M`;
    if (count >= 1000) return `${(count / 1000).toFixed(1)}K`;
    return count.toString();
  };

  const formatViews = (count: any) => {
    if (typeof count !== 'number' || isNaN(count)) return '0';
    if (count >= 1000000) return `${(count / 1000000).toFixed(1)}M`;
    if (count >= 1000) return `${(count / 1000).toFixed(1)}K`;
    return count.toString();
  };

  // 统一数据源，分页全部基于 currentData
  const currentData = useMemo(() => {
    let data;
    if (activeTab === 'live' || activeTab === 'upcoming' || activeTab === 'replays') {
      data = liveList;
    } else if (activeTab === 'following') {
      if (selectedTeam) {
        data = teamMatches;
      } else {
        data = followingTeams;
      }
    } else {
      data = liveList;
    }
    if (!selectedSport || selectedSport.name === '全部') {
      return Array.isArray(data) ? data : [];
    }
    const filtered = Array.isArray(data) ? data.filter((item: any) => {
      if (typeof item.category === 'object' && item.category?.name) {
        return item.category.name === selectedSport.name;
      }
      return item.category === selectedSport.name || item.sport === selectedSport.name;
    }) : [];
    return filtered;
  }, [liveList, activeTab, selectedTeam, selectedSport, followingTeams]);

  // 分页
  const totalPages = Math.ceil(currentData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const pagedData = currentData.slice(startIndex, endIndex);

  const handleTabChange = (tab: 'live' | 'upcoming' | 'replays' | 'following') => {
    setActiveTab(tab);
    setCurrentPage(1);
    if (tab !== 'following') {
setSelectedTeam(null);
    }
  };

  const handleSearchChange = (query: string) => {
    setSearchQuery(query);
    setCurrentPage(1);
  };

  const handleVideoPreview = (item: any) => {
    if (item.videoUrl) {
      setPreviewVideo(item);
    }
  };

  const closeVideoPreview = () => {
    setPreviewVideo(null);
  };

  const handleMouseEnter = (itemId: string, videoUrl: string) => {
    if (!videoUrl) return;
    setHoveredVideo(itemId);
    if (!videoRefs.current[itemId]) {
      const video = document.createElement('video');
      video.src = videoUrl;
      video.muted = true;
      video.preload = 'metadata';
      videoRefs.current[itemId] = video;
    }
    const video = videoRefs.current[itemId];
    if (video) {
      video.currentTime = 0;
      let timeElapsed = 0;
      setPreviewTime(prev => ({ ...prev, [itemId]: 0 }));
      previewIntervals.current[itemId] = setInterval(() => {
        timeElapsed += 1;
        setPreviewTime(prev => ({ ...prev, [itemId]: timeElapsed }));
        if (video.duration && !isNaN(video.duration)) {
          const jumpInterval = video.duration / 10;
          video.currentTime = (timeElapsed * jumpInterval) % video.duration;
        }
        if (timeElapsed >= 10) {
          clearInterval(previewIntervals.current[itemId]);
          setPreviewTime(prev => ({ ...prev, [itemId]: 0 }));
          video.currentTime = 0;
        }
      }, 1000);
    }
  };

  const handleMouseLeave = (itemId: string) => {
    setHoveredVideo(null);
    if (previewIntervals.current[itemId]) {
      clearInterval(previewIntervals.current[itemId]);
      delete previewIntervals.current[itemId];
    }
    setPreviewTime(prev => ({ ...prev, [itemId]: 0 }));
    const video = videoRefs.current[itemId];
    if (video) {
      video.currentTime = 0;
    }
  };
  console.log( adListobj2.title)
  const renderContent = () => {
    if (activeTab === 'following') {
      if (selectedTeam) {
        
        return (
          <div>
            {/* 队伍信息和返回按钮 */}
            <div className="mb-6 p-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border border-blue-100">
              <div className="flex items-center justify-between mb-4">
                <button
                  onClick={() => setSelectedTeam(null)}
                  className="flex items-center text-blue-600 hover:text-blue-700 transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-left-line mr-2"></i>
                  <span className="text-sm">返回关注列表</span>
                </button>
                <div className="flex items-center text-sm text-gray-600">
                  <i className="ri-heart-fill text-red-500 mr-1"></i>
                  已关注
                </div>
              </div>
              
              <div className="flex items-center">
                <img
                  src={selectedTeam.logo}
                  alt={selectedTeam.name}
                  className="w-16 h-16 rounded-full mr-4 object-cover"
                />
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-1">{selectedTeam.name}</h3>
                  <p className="text-gray-600 text-sm mb-2">{selectedTeam.league} · {selectedTeam.sport}</p>
                  <div className="flex items-center space-x-4 text-xs text-gray-500">
                    <span>{formatViewers(selectedTeam.number)} 关注者</span>
                    <span>{selectedTeam.upcomingMatches} 场即将开始</span>
                  </div>
                </div>
              </div>
            </div>

            {/* 队伍赛事列表 */}
            <div className={`grid gap-4 md:gap-5 ${isLivePage ? 'grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5' : 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3'}`}>
              {teamMatches.map((match: any) => (
                <div
                  key={match.id}
                  className="bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden cursor-pointer"
                >
                  <div 
                    className="relative group" 
                    onClick={() => handleVideoPreview(match)}
                    onMouseEnter={() => match.videoUrl && handleMouseEnter(match.id, match.videoUrl)}
                    onMouseLeave={() => handleMouseLeave(match.id)}
                  >
                    <img
                      src={match.thumbnail||'https://readdy.ai/api/search-image?query=professional%20$%7Bteam.sport%7D%20match%20in%20progress%2C%20modern%20sports%20stadium%20with%20bright%20lighting%2C%20players%20competing%20in%20$%7Bteam.sport%7D%20game%2C%20dynamic%20sports%20action%20scene%20with%20vibrant%20green%20field&width=400&height=300&seq=1-match-1&orientation=landscape'}
                      alt={match.title}
                      className={`w-full object-cover object-top transition-transform duration-300 ${isLivePage ? 'h-24 sm:h-28 md:h-32 lg:h-36' : 'h-40 md:h-36'} group-hover:scale-105`}
                    />

                    {match.status === 'live' && (
                      <>
                        <div className="absolute top-2 left-2 bg-red-500 text-white px-1.5 py-0.5 rounded-full text-xs font-medium flex items-center">
                          <div className="w-1 h-1 bg-white rounded-full mr-1 animate-pulse"></div>
                          直播中
                        </div>
                        <div className="absolute top-2 right-2 bg-black/70 text-white px-1.5 py-0.5 rounded text-xs flex items-center">
                          <i className="ri-eye-line mr-1 text-xs"></i>
                          {formatViewers(match.viewers)}
                        </div>
                      </>
                    )}

                    {match.status === 'upcoming' && (
                      <div className="absolute top-2 left-2 bg-green-500 text-white px-1.5 py-0.5 rounded-full text-xs font-medium">
                        即将开始
                      </div>
                    )}

                    {match.status === 'replay' && (
                      <>
                        <div className="absolute inset-0 bg-black/20"></div>
                        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                          <div className={`bg-white/90 rounded-full flex items-center justify-center ${isLivePage ? 'w-8 h-8 md:w-10 md:h-10' : 'w-10 h-10'}`}>
                            <i className={`ri-play-fill text-green-600 ml-0.5 ${isLivePage ? 'text-sm md:text-lg' : 'text-lg'}`}></i>
                          </div>
                        </div>
                        <div className="absolute bottom-2 right-2 bg-black/70 text-white px-1.5 py-0.5 rounded text-xs">
                          {match.duration}
                        </div>
                        
                        {/* 收藏按钮 - 只在回放标签页显示 */}
                        <button
                          type="button"
                          onClick={(e) => handleFavoriteReplay(e, match)}
                          className={`absolute top-2 right-2 w-7 h-7 rounded-full flex items-center justify-center transition-all duration-300 z-10 ${favoriteReplays.has(match.id)|| match.is_focus ? 'bg-red-500 text-white shadow-lg' : 'bg-white/80 text-gray-600 hover:bg-white hover:text-red-500' } hover:scale-110`}
                          title={favoriteReplays.has(match.id) || match.is_focus ? '取消收藏' : '收藏回放'}
                        >
                          <i className={`text-xs ${favoriteReplays.has(match.id)|| match.is_focus ? 'ri-heart-fill' : 'ri-heart-line'}`}></i>
                        </button>
                      </>
                    )}
                  </div>

                  <div className={`${isLivePage ? 'p-2 md:p-3' : 'p-3 md:p-4'}`}>
                    <div className="flex items-center justify-between mb-2">
                      <span className={`font-medium px-1.5 py-0.5 rounded-full ${match.status === 'live' ? 'text-red-600 bg-red-50' : match.status === 'upcoming' ? 'text-green-600 bg-green-50' : 'text-green-600 bg-green-50'} ${isLivePage ? 'text-xs' : 'text-xs'}`}>
                        {match.league_name}
                      </span>
                      <span className={`text-gray-500 ${isLivePage ? 'text-xs' : 'text-xs'}`}>
                        { match.start_time}
                      </span>
                    </div>

                    <h3 className={`font-bold text-gray-900 mb-3 leading-tight line-clamp-2 ${isLivePage ? 'text-xs md:text-sm' : 'text-sm'}`}>
                      {match.home}vs{match.away}
                    </h3>

                    <Button
                      className={`w-full whitespace-nowrap ${isLivePage ? 'text-xs px-2 py-1' : 'text-xs'}`}
                      variant={match.status === 'live' ? 'primary' : 'outline'}
                      size="sm"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (match.videoUrl) {
                          handleVideoPreview(match);
                        }
                      }}
                    >
                      {match.status === 'live' ? (
                        <>
                          <i className="ri-play-circle-line mr-1"></i>
                          {isLivePage ? '观看' : '立即观看'}
                        </>
                      ) : match.status === 'upcoming' ? (
                        <>
                          <i className="ri-notification-line mr-1"></i>
                          {isLivePage ? '提醒' : '设置提醒'}
                        </>
                      ) : (
                        <>
                          <i className="ri-play-circle-line mr-1"></i>
                          {isLivePage ? '回放' : '观看回放'}
                        </>
                      )}
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
      }

      // "关注" 标签页的队伍列表
      return (
        <div className="space-y-3">
          {pagedData.map((team: any) => (
            <div
              key={team.id}
              className="bg-white rounded-lg shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden group cursor-pointer border border-gray-100 hover:border-green-200"
              onClick={() => setSelectedTeam(team)}
            >
              <div className="p-4">
                <div className="flex items-center justify-between">
                  {/* 左侧：队伍信息 */}
                  <div className="flex items-center space-x-4 flex-1">
                    <div className="relative">
                      <img
                        src={team.logo}
                        alt={team.name}
                        className="w-12 h-12 md:w-14 md:h-14 rounded-full object-cover shadow-lg"
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center space-x-2 mb-1">
                        <h3 className="font-bold text-gray-900 text-base md:text-lg truncate">
                          {team.name}
                        </h3>
                        <span className="px-2 py-1 bg-blue-100 text-blue-700 rounded-full text-xs font-medium whitespace-nowrap">
                          {team.sport}
                        </span>
                      </div>
                      
                      <p className="text-gray-600 text-sm mb-2">{team.league}</p>
                      
                    </div>
                  </div>

                  {/* 中间：近期战绩 */}
                  <div className="hidden md:flex items-center space-x-3 mx-6">
                    <span className="text-sm text-gray-500">近期战绩:</span>
                    {Array.isArray(team.recentForm) && team.recentForm.length > 0 && (
                      <div className="flex space-x-1 mt-1">
                        {team.recentForm.slice(0, 5).map((form: string, idx: number) => (
                          <span key={idx} className={`px-1 py-0.5 rounded text-xs ${form === 'W' ? 'bg-green-100 text-green-600' : form === 'L' ? 'bg-red-100 text-red-600' : 'bg-gray-100 text-gray-600'}`}>
                            {form}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>

                  {/* 右侧：操作按钮 */}
                  <div className="flex items-center space-x-3">
                    {team.upcomingMatches > 0 && (
                      <div className="hidden sm:flex items-center px-3 py-1.5 bg-green-100 text-green-700 rounded-full text-xs font-medium">
                        <i className="ri-play-circle-line mr-1"></i>
                        {team.upcomingMatches} 场直播
                      </div>
                    )}
                    
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleFollowToggle(team)
                        console.log('取消关注队伍:', team.id);
                      }}
                      className="px-3 py-1.5 bg-red-100 text-red-600 hover:bg-red-200 rounded-full text-xs font-medium transition-colors cursor-pointer whitespace-nowrap"
                    >
                      <i className="ri-heart-line mr-1"></i>
                      取消关注
                    </button>
                    
                    <div className="flex items-center text-green-600 group-hover:text-green-700">
                      <span className="text-sm font-medium whitespace-nowrap">查看赛事</span>
                      <i className="ri-arrow-right-line ml-2 text-sm group-hover:translate-x-1 transition-transform"></i>
                    </div>
                  </div>

                </div>

                {/* 移动端战绩显示 */}
                <div className="md:hidden mt-3 pt-3 border-t border-gray-100">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-2">
                      <span className="text-xs text-gray-500">近期:</span>
                      {Array.isArray(team.recentForm) && team.recentForm.length > 0 && (
                        <div className="flex space-x-1 mt-1">
                          {team.recentForm.slice(0, 5).map((form: string, idx: number) => (
                            <span key={idx} className={`px-1 py-0.5 rounded text-xs ${form === 'W' ? 'bg-green-100 text-green-600' : form === 'L' ? 'bg-red-100 text-red-600' : 'bg-gray-100 text-gray-600'}`}>
                              {form}
                            </span>
                          ))}
                        </div>
                      )}
                    </div>
                    
                    {team.upcomingMatches > 0 && (
                      <div className="flex items-center px-2 py-1 bg-green-100 text-green-700 rounded-full text-xs font-medium">
                        <i className="ri-play-circle-line mr-1"></i>
                        {team.upcomingMatches} 场
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}

          {/* 添加更多关注 */}
          {currentPage === 1 && (
            <div 
              className="bg-gradient-to-r from-gray-50 to-gray-100 rounded-lg border-2 border-dashed border-gray-300 hover:border-green-400 hover:from-green-50 hover:to-emerald-50 transition-all cursor-pointer p-4"
              onClick={() => {
                navigate('/teams');
              }}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 md:w-14 md:h-14 bg-gray-300 rounded-full flex items-center justify-center">
                    <i className="ri-add-line text-xl text-gray-500"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-700 mb-1 text-base">关注更多队伍</h3>
                    <p className="text-gray-500 text-sm">发现更多精彩赛事和你喜爱的运动队伍</p>
                  </div>
                </div>
                
                <div className="flex items-center text-green-600 hover:text-green-700">
                  <span className="text-sm font-medium whitespace-nowrap">立即浏览</span>
                  <i className="ri-arrow-right-line ml-2 text-sm"></i>
                </div>
              </div>
            </div>
          )}
        </div>
      );
    }

    // "直播"、"即将开始"、"回放" 等标签页的通用渲染逻辑
    return (
      <div>
        {pagedData.length === 0 ? (
          <div className="text-center py-10">
            <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-3">
              <i className="ri-live-line text-gray-400 text-lg"></i>
            </div>
            <h3 className="text-base font-medium text-gray-900 mb-2">暂无{selectedSport?.name}相关内容</h3>
            <p className="text-gray-500 text-sm">
              {activeTab === 'live' ? '当前没有进行中的' : 
               activeTab === 'upcoming' ? '暂无即将开始的' :
               activeTab === 'replays' ? '暂无' : '暂无用户'}
              {selectedSport?.name}赛事或直播
            </p>
          </div>
        ) : (
          <div className={`grid gap-4 md:gap-5 ${isLivePage ? 'grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5' : 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3'}`}>
            {pagedData.map((match: any) => (
              <div
                key={match.id}
                className="bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden cursor-pointer"
              >
                {/* 视频预览区域 */}
                <div 
                  className="relative group" 
                  onClick={() => handleVideoPreview(match)}
                  onMouseEnter={() => match.videoUrl && handleMouseEnter(match.id, match.videoUrl)}
                  onMouseLeave={() => handleMouseLeave(match.id)}
                >
                  {/* 正在直播页面显示截图，悬停时播放实时直播画面 */}
                  {activeTab === 'live' ? (
                    <div className={`w-full bg-black relative overflow-hidden ${isLivePage ? 'h-24 sm:h-28 md:h-32 lg:h-36' : 'h-40 md:h-36'}`}>
                      {/* 默认显示的截图 */}
                      <img
                        src={match.thumbnail}
                        alt={match.title}
                        className={`w-full h-full object-cover object-top transition-all duration-300 ${hoveredVideo === match.id ? 'opacity-0 scale-105' : 'opacity-100 group-hover:scale-105'}`}
                      />
                      
                      {/* 悬停时显示的实时视频 */}
                      {match.videoUrl && hoveredVideo === match.id && (
                        <video
                          className="absolute inset-0 w-full h-full object-cover"
                          autoPlay
                          muted
                          playsInline
                          loop
                          onError={(e) => {
                            const target = e.target as HTMLVideoElement;
                            target.style.display = 'none';
                            const parent = target.parentElement;
                            if (parent) {
                              const errorDiv = parent.querySelector('.stream-error');
                              if (errorDiv) {
                                errorDiv.classList.remove('hidden');
                              }
                            }
                          }}
                        >
                          <source src={match.videoUrl} type="video/mp4" />
                        </video>
                      )}
                      
                      {/* 直播中断提示 */}
                      <div className="stream-error absolute inset-0 bg-gray-900 flex items-center justify-center text-white hidden">
                        <div className="text-center">
                          <i className={`ri-wifi-off-line mb-1 md:mb-2 text-red-400 ${isLivePage ? 'text-xl md:text-3xl' : 'text-3xl'}`}></i>
                          <p className={`font-medium ${isLivePage ? 'text-xs md:text-sm' : 'text-sm'}`}>直播中断</p>
                          <p className={`text-gray-400 mt-1 ${isLivePage ? 'text-xs hidden md:block' : 'text-xs'}`}>信号暂时中断，正在重连</p>
                        </div>
                      </div>
                      
                      {/* 无视频源时的中断提示 */}
                      {!match.videoUrl && (
                        <div className="absolute inset-0 bg-gray-900/80 flex items-center justify-center text-white">
                          <div className="text-center">
                            <i className={`ri-wifi-off-line mb-1 md:mb-2 text-red-400 ${isLivePage ? 'text-xl md:text-3xl' : 'text-3xl'}`}></i>
                            <p className={`font-medium ${isLivePage ? 'text-xs md:text-sm' : 'text-sm'}`}>直播中断</p>
                            <p className={`text-gray-400 mt-1 ${isLivePage ? 'text-xs hidden md:block' : 'text-xs'}`}>信号暂时中断，正在重连</p>
                          </div>
                        </div>
                      )}
                    </div>
                  ) : (
                    <img
                      src={match.thumbnail}
                      alt={match.title}
                      className={`w-full object-cover object-top transition-transform duration-300 ${hoveredVideo === match.id ? 'scale-105' : 'group-hover:scale-105'} ${isLivePage ? 'h-24 sm:h-28 md:h-32 lg:h-36' : 'h-40 md:h-36'}`}
                    />
                  )}

                  {activeTab === 'live' && (
                    <>
                      <div className="absolute top-2 left-2 bg-red-500 text-white px-1.5 py-0.5 rounded-full text-xs font-medium flex items-center">
                        <div className="w-1 h-1 bg-white rounded-full mr-1 animate-pulse"></div>
                        直播中
                      </div>
                      {match.viewers > 0 && (
                        <div className="absolute top-2 right-2 bg-black/70 text-white px-1.5 py-0.5 rounded text-xs flex items-center">
                          <i className="ri-eye-line mr-1 text-xs"></i>
                          {formatViewers(match.viewers)}
                        </div>
                      )}
                      
                      {/* 悬停播放提示 - 只在直播页面显示 */}
                      {match.videoUrl && !hoveredVideo && (
                        <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                          <div className="bg-white/90 text-gray-900 px-2 py-1 rounded-full text-xs flex items-center">
                            <i className="ri-play-line mr-1"></i>
                            <span className={isLivePage ? 'hidden sm:inline' : ''}>悬停播放</span>
                          </div>
                        </div>
                      )}
                    </>
                    )}

                  {activeTab === 'replays' && (
                    <>
                      <div className="absolute inset-0 bg-black/20"></div>
                      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                        <div className={`bg-white/90 rounded-full flex items-center justify-center ${isLivePage ? 'w-8 h-8 md:w-10 md:h-10' : 'w-10 h-10'}`}>
                          <i className={`ri-play-fill text-green-600 ml-0.5 ${isLivePage ? 'text-sm md:text-lg' : 'text-lg'}`}></i>
                        </div>
                      </div>
                      <div className="absolute bottom-2 right-2 bg-black/70 text-white px-1.5 py-0.5 rounded text-xs">
                        {match.duration}
</div>
                      
                      {/* 收藏按钮 - 只在回放标签页显示 */}
                      <button
                        type="button"
                        onClick={(e) => handleFavoriteReplay(e, match)}
                        className={`absolute top-2 right-2 w-7 h-7 rounded-full flex items-center justify-center transition-all duration-300 z-10 ${favoriteReplays.has(match.id)|| match.is_focus ? 'bg-red-500 text-white shadow-lg' : 'bg-white/80 text-gray-600 hover:bg-white hover:text-red-500' } hover:scale-110`}
                        title={favoriteReplays.has(match.id)|| match.is_focus ? '取消收藏' : '收藏回放'}
                      >
                        <i className={`text-xs ${favoriteReplays.has(match.id)|| match.is_focus ? 'ri-heart-fill' : 'ri-heart-line'}`}></i>
                      </button>
                    </>
                  )}

                  {activeTab === 'upcoming' && (
                    <div className="absolute top-2 left-2 bg-green-500 text-white px-1.5 py-0.5 rounded-full text-xs font-medium">
                      即将开始
                    </div>
                  )}

                  {/* 悬停预览提示和进度 */}
                  {hoveredVideo === match.id ? (
                    <div className="absolute top-2 left-2 bg-blue-500/90 text-white px-2 py-0.5 rounded text-xs z-10">
                      <i className="ri-play-line mr-1"></i>
                      预览中 {previewTime[match.id] || 0}/10秒
                    </div>
                  ) : match.videoUrl && activeTab !== 'live' && (
                    <div className="absolute top-2 left-2 bg-blue-500/90 text-white px-2 py-0.5 rounded text-xs opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <i className="ri-zoom-in-line mr-1"></i>
                      <span className={isLivePage ? 'hidden md:inline' : ''}>悬停10秒预览</span>
                    </div>
                  )}

                  {/* 预览进度条 */}
                  {hoveredVideo === match.id && previewTime[match.id] > 0 && activeTab !== 'live' && (
                    <div className="absolute bottom-2 left-2 right-16">
                      <div className="w-full bg-white/20 rounded-full h-1">
                        <div className="bg-blue-500 h-1 rounded-full transition-all duration-1000" style={{ width: `${((previewTime[match.id] || 0) / 10) * 100}%` }}></div>
                      </div>
                    </div>
                  )}

                  {/* 悬停预览播放按钮 - 只在有视频链接且非直播页面时显示 */}
                  {match.videoUrl && activeTab !== 'live' && (
                    <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                      <div className={`bg-white/90 rounded-full flex items-center justify-center ${isLivePage ? 'w-8 h-8 md:w-12 md:h-12' : 'w-12 h-12'}`}>
                        <i className={`ri-play-fill text-green-600 ml-0.5 ${isLivePage ? 'text-sm md:text-xl' : 'text-xl'}`}></i>
                      </div>
                    </div>
                  )}
                </div>

                <div className={`${isLivePage ? 'p-2 md:p-3' : 'p-3 md:p-4'}`}>
                  {/* 体育赛事类型 */}
                  <div className="flex items-center justify-between mb-2">
                    <span className={`font-medium px-1.5 py-0.5 rounded-full ${activeTab === 'live' ? 'text-red-500 bg-red-50' : activeTab === 'upcoming' ? 'text-green-500 bg-green-50' : 'text-green-500 bg-green-50'} ${isLivePage ? 'text-xs' : 'text-xs'}`}>
                      {/* 修复 category 为对象时报错 */}
                      {typeof match.category === 'object' && match.category?.name
                        ? match.category.name
                        : match.category} · {match.league_name}
                    </span>
                    <span className={`text-gray-500 ${isLivePage ? 'text-xs' : 'text-xs'}`}>
                      {activeTab === 'replays' ? match.date : activeTab === 'upcoming' ? match.time : match.time}
                    </span>
                  </div>

                  {/* 比赛队伍 */}
                  <h3 className={`font-bold text-gray-900 mb-2 leading-tight line-clamp-2 ${isLivePage ? 'text-xs md:text-sm' : 'text-sm'}`}>
                    {match.home}vs{match.away}
                  </h3>

                  {/* 比赛进度和比分 */}
                  <div className="space-y-1 mb-3">
                    {activeTab === 'live' && (
                      <>
                        <div className={`flex items-center justify-between ${isLivePage ? 'text-xs' : 'text-xs'}`}>
                          <span className="text-gray-600">比赛时间</span>
                          <span className="font-medium text-red-600">{match.start_time}</span>
                        </div>
                        <div className="text-center py-1.5 bg-red-50 rounded border border-red-100">
                          <div className="flex items-center justify-center">
                            <div className="w-1.5 h-1.5 bg-red-500 rounded-full mr-2 animate-pulse"></div>
                            <span className={`font-medium text-red-600 ${isLivePage ? 'text-xs' : 'text-xs'}`}>进行中</span>
                          </div>
                        </div>
                      </>
                    )}
                    {activeTab === 'upcoming' && (
                      <div className={`flex items-center justify-between ${isLivePage ? 'text-xs' : 'text-xs'}`}>
                        <span className="text-gray-600">开始时间</span>
                        <span className="font-medium text-green-600">{match.time}</span>
                      </div>
                    )}
                    {activeTab === 'replays' && (
                      <>
                        <div className={`flex items-center justify-between ${isLivePage ? 'text-xs' : 'text-xs'}`}>
                          <span className="text-gray-600">比赛日期</span>
                          <span className="font-medium text-gray-900">{match.date}</span>
                        </div>
                        <div className={`flex items-center justify-between ${isLivePage ? 'text-xs' : 'text-xs'}`}>
                          <div className="flex items-center text-gray-600">
                            <i className="ri-eye-line mr-1 text-xs"></i>
                            <span>{formatViews(match.views)} 观看</span>
                          </div>
                          <div className="flex items-center space-x-2">
                            <span className="text-gray-600">{match.duration}</span>
                            <button
                              type="button"
                              onClick={(e) => handleFavoriteReplay(e, match)}
                              className={`flex items-center text-gray-600 hover:text-red-500 cursor-pointer transition-colors ${favoriteReplays.has(match.id) ? 'text-red-500' : ''}`}
                              title={favoriteReplays.has(match.id) ? '已收藏' : '收藏'}
                            >
                              <i className={`text-xs ${favoriteReplays.has(match.id) ? 'ri-heart-fill' : 'ri-heart-line'}`}></i>
                            </button>
                          </div>
                        </div>
                      </>
                    )}
                  </div>

                  <Button
                    className={`w-full ${isLivePage ? 'text-xs px-2 py-1' : 'text-xs'}`}
                    variant={activeTab === 'live' ? 'primary' : 'outline'}
                    size="sm"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (match.videoUrl) {
                        handleVideoPreview(match);
                      }
                    }}
                  >
                    {activeTab === 'live' ? (
                      <>
                        <i className="ri-play-circle-line mr-1"></i>
                        {isLivePage ? '观看' : '立即观看'}
                      </>
                    ) : activeTab === 'upcoming' ? (
                      <>
                        <i className="ri-notification-line mr-1"></i>
                        {isLivePage ? '提醒' : '设置提醒'}
                      </>
                    ) : (
                      <>
                        <i className="ri-play-circle-line mr-1"></i>
                        {isLivePage ? '回放' : '观看回放'}
                      </>
                    )}
                  </Button>
                </div>
              </div>
            ))}

            {/* 内容中间插入广告卡片 - 只在第一页显示 */}
  
            {currentPage === 1 && adListobj?.title && (
              <div className="bg-gradient-to-br from-yellow-400 via-orange-500 to-red-500 rounded-lg p-4 md:p-5 text-white">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="font-bold text-base md:text-lg mb-1">🔥 {adListobj?.title || '热门推荐'}</h3>
                    <p className="text-white/90 text-sm">{adListobj?.sub_title || '精彩体育周边商品，限时优惠中'}</p>
                  </div>
                  <button onClick={() => handleAdClick(adListobj.jump_url)} className="bg-white text-orange-600 px-3 py-1.5 rounded-lg text-sm font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap">
                    {adListobj?.btn_tip || '查看详情'}
                  </button>
                </div>
              </div>
            )}
          </div>
        )}

        {/* 内容列表底部广告 - 只在第一页显示 */}
        {currentPage === 1 && currentData.length > 0 && adListobj2?.title && (
          <div className={`mt-6 bg-gradient-to-r from-green-500 via-emerald-500 to-teal-500 rounded-lg text-white text-center ${isLivePage ? 'p-3 md:p-4' : 'p-4 md:p-5'}`}>
            <h3 className={`font-bold mb-2 ${isLivePage ? 'text-base md:text-lg' : 'text-lg'}`}>{adListobj2?.title || '体育游戏竞猜'}</h3>
            <p className={`text-white/90 mb-3 ${isLivePage ? 'text-xs md:text-sm' : 'text-sm'}`}>{adListobj2?.sub_title || '预测比赛结果，赢取丰厚奖品'}</p>
            <div className="flex flex-col sm:flex-row justify-center gap-3">
              <button onClick={() => handleAdClick(adListobj2.jump_url)} className={`bg-white text-green-600 rounded-lg font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap ${isLivePage ? 'px-3 py-1 text-xs' : 'px-4 py-1.5 text-xs'}`}>
                {adListobj2?.btn_tip || '立即参与'}
              </button>
              <button onClick={() => handleAdClick(adListobj2.jump_url2)} className={`border-2 border-white text-white rounded-lg font-semibold hover:bg-white hover:text-green-600 transition-colors cursor-pointer whitespace-nowrap ${isLivePage ? 'px-3 py-1 text-xs' : 'px-4 py-1.5 text-xs'}`}>
                {adListobj2?.btn_tip2 || '查看规则'}
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <div className="flex-1">
        {/* 搜索框 */}
        <div className="mb-4 md:mb-6">
          <div className="relative max-w-md mx-auto">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <i className="ri-search-line text-gray-400 text-sm"></i>
            </div>
            <input
              type="text"
              placeholder={`搜索${selectedSport?.name !== '全部' ? selectedSport?.name : ''}${activeTab === 'following' ? (selectedTeam ? '赛事...' : '关注的队伍...') : '赛事、队伍、直播间...'}`}
              value={searchQuery}
              onChange={(e) => handleSearchChange(e.target.value)}
              className="w-full pl-10 pr-4 py-3 md:py-2.5 border border-gray-200 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 outline-none transition-colors text-sm"
            />
            {searchQuery && (
              <button
                onClick={() => handleSearchChange('')}
                className="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer"
              >
                <i className="ri-close-line text-gray-400 hover:text-gray-600 text-sm"></i>
              </button>
            )}
          </div>
        </div>

        {/* Tab Switcher */}
        <div className="flex justify-center mb-4 md:mb-6 px-2">
          <div className="bg-white rounded-full p-1 shadow-md flex flex-wrap gap-1 w-full max-w-2xl">
            <button
              onClick={() => handleTabChange('live')}
              className={`flex-1 px-2 md:px-3 py-2 md:py-1.5 rounded-full font-medium transition-all duration-200 cursor-pointer whitespace-nowrap text-xs flex items-center justify-center ${activeTab === 'live' ? 'bg-red-500 text-white shadow-md' : 'text-gray-600 hover:text-red-500'}`}
            >
              <i className="ri-live-fill mr-1"></i>
              <span className="hidden sm:inline">正在</span>直播
            </button>
            <button
              onClick={() => handleTabChange('upcoming')}
              className={`flex-1 px-2 md:px-3 py-2 md:py-1.5 rounded-full font-medium transition-all duration-200 cursor-pointer whitespace-nowrap text-xs flex items-center justify-center ${activeTab === 'upcoming' ? 'bg-green-500 text-white shadow-md' : 'text-gray-600 hover:text-green-500'}`}
            >
              <i className="ri-calendar-line mr-1"></i>
              即将<span className="hidden sm:inline">开始</span>
            </button>
            <button
              onClick={() => handleTabChange('replays')}
              className={`flex-1 px-2 md:px-3 py-2 md:py-1.5 rounded-full font-medium transition-all duration-200 cursor-pointer whitespace-nowrap text-xs flex items-center justify-center ${activeTab === 'replays' ? 'bg-green-500 text-white shadow-md' : 'text-gray-600 hover:text-green-500'}`}
            >
              <i className="ri-play-circle-line mr-1"></i>
              <span className="hidden sm:inline">精彩</span>回放
            </button>
            <button
              onClick={() => handleTabChange('following')}
              className={`flex-1 px-2 md:px-3 py-2 md:py-1.5 rounded-full font-medium transition-all duration-200 cursor-pointer whitespace-nowrap text-xs flex items-center justify-center ${activeTab === 'following' ? 'bg-blue-500 text-white shadow-md' : 'text-gray-600 hover:text-blue-500'}`}
              data-user-stream-tab
            >
              <i className="ri-heart-line mr-1"></i>
              关注
            </button>
          </div>
        </div>

                {/* Content */}
                {searchQuery && currentData.length === 0 ? (
                  <div className="text-center py-10">
                    <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-3">
                      <i className="ri-search-line text-gray-400 text-lg"></i>
                    </div>
                    <h3 className="text-base font-medium text-gray-900 mb-2">未找到相关内容</h3>
                    <p className="text-gray-500 text-sm">尝试使用其他关键词搜索</p>
                  </div>
                ) : (
                  <>
                    {renderContent()}
                    
                    {/* 分页控件 */}
                    {totalPages > 1 && (
                      <div className="flex items-center justify-center mt-6 md:mt-8 space-x-2 px-4">
                        {/* 上一页按钮 */}
                        <button
                          onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                          disabled={currentPage === 1}
                          className="px-3 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer text-xs flex items-center whitespace-nowrap"
                        >
                          <i className="ri-arrow-left-line mr-1"></i>
                          <span className="hidden sm:inline">上一页</span>
                        </button>
                    
                        {/* 页码按钮 */}
                        <div className="flex items-center space-x-1">
                          {Array.from({ length: Math.min(totalPages, 5) }, (_, i) => {
                            let page;
                            if (totalPages <= 5) {
                              page = i + 1;
                            } else if (currentPage <= 3) {
                              page = i + 1;
                            } else if (currentPage >= totalPages - 2) {
                              page = totalPages - 4 + i;
                            } else {
                              page = currentPage - 2 + i;
                            }
                            return (
                              <button
                                key={page}
                                onClick={() => setCurrentPage(page)}
                                className={`px-3 py-2 rounded-lg cursor-pointer text-xs whitespace-nowrap ${currentPage === page ? 'bg-green-500 text-white' : 'border border-gray-300 text-gray-600 hover:bg-gray-50'}`}
                              >
                                {page}
                              </button>
                            );
                          })}
                        </div>
                    
                        {/* 下一页按钮 */}
                        <button
                          onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                          disabled={currentPage === totalPages}
                          className="px-3 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer text-xs flex items-center whitespace-nowrap"
                        >
                          <span className="hidden sm:inline">下一页</span>
                          <i className="ri-arrow-right-line ml-1"></i>
                        </button>
                      </div>
                    )}
                
                    {/* 内容统计信息 */}
                    {currentData.length > 0 && (
                      <div className="text-center mt-4 text-xs text-gray-500">
                        显示第 {startIndex + 1}-{Math.min(endIndex, currentData.length)} 项，共 {currentData.length} 项结果
                        {selectedSport?.name !== '全部' && ` · ${selectedSport?.name}分类`}
                      </div>
                    )}
                  </>
                )}
      </div>

      {/* 视频预览弹窗 */}
      {previewVideo && (
        <VideoPreview
          videoUrl={previewVideo.videoUrl}
          thumbnail={previewVideo.thumbnail}
          title={previewVideo.title}
          isLive={previewVideo.status === 'live' || previewVideo.isLive}
          isReplay={activeTab === 'replays'}
          onClose={closeVideoPreview}
        />
      )}
    </>
  );
}

